module.exports = __webpack_public_path__ + "img/about2.67e41b4f.png";